import { createRootRoute, Outlet } from '@tanstack/react-router';
import { Toaster } from 'sonner';
import '../styles/globals.css';
import { NotFoundComponent } from '../components/layout/not-found';
import { AppProviders } from '../providers/AppProviders';

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFoundComponent,
});

function RootComponent() {
  return (
    <AppProviders>
      <Outlet />
      <Toaster position="top-center" richColors />
    </AppProviders>
  );
}
